<template>
  <div class="list row">
    <h2>Kasko</h2>
    <div class="actions d-flex flex-row-reverse">
      <button type="button" class="btn btn-primary bi bi-arrow-clockwise" @click="refreshData" />
      <button type="button" class="btn btn-success bi bi-plus" @click="addData" />
    </div>
    <data-table url="kasko" :columns="columns" :templates="templates" :headings="headers" :actions="actions"
      ref="datatable" @yes="deleteData" name="Kasko">
    </data-table>
  </div>
</template>

<script>
import KaskoDataService from "../../services/kasko.service";
import DataTable from "../widgets/DataTable.vue";
import KaskoForm from "./KaskoForm.vue";

export default {
  name: "kasko",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: [
        "valid_from",
        "active",
        "edit",
      ],
      headers: {
        valid_from: "Važi od",
        active: "Aktivno",
        edit: "",
      },
      templates: {
        active: function (h, row) {
          return row.active == 1 ? 'Aktivno' : 'Neaktivno';
        }
      },
      actions: {
        edit: { commp: KaskoForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
      },
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: KaskoForm,
        params: { data: {}, title: "Dodaj novi Kasko" },
      });
    },
    deleteData(data) {
      KaskoDataService.deleteByValidFrom(data.valid_from)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message,
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e.response?.data?.message || e.message || "Error deleting Kasko",
          });
        });
    },
  },
};
</script>

<style scoped>
.list {
  text-align: left;
  margin: auto;
}
</style>
